<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/JwafVS/tc-custom/9781460362648.jpg?1725275587450" alt="This image is the cover for the book Final Stand"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Final Stand
      </h1>
      <p class="bookDescription body article font2">
        <b>For two terror-filled days, </b>Las Vegas cop Sasha Mills has been on the run. Now, in a remote stretch of southwest Texas, she is compelled to take a chance in a town called Bitters.<br/><br/>But her timing couldn't be worse. As the only stranger in town, she becomes the prime suspect in an arson investigationthrusting her into a spotlight that could cost her her life.<br/><br/>Because deadly danger is in fast pursuit. An international crime ring has targeted her as one of two loose ends to tie up. They <i>need</i> Sasha silenced. Then tragedy strikes, and running is no longer an option for this tough lady cop.<br/><br/>It's time for payback.<br/><br/>It's time to make a final stand. For justice.<br/><br/>For family. For love.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Helen R. Myers
      </h2>
      
      <p class="authorDescription body article">Helen R. Myers is a Texan by choice, and when not writing, she's spoiling her four rescued dogs.&#160; A avid follower of the news&#160;and student of astrology, she enjoys comparing planetary aspects with daily world events.&#160; To decompress, she experiments with all forms of gardening and cooking with the produce she raises.&#160;&#160;You can contact her through her website at helenr.myers.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Harlequin
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?486a9148